module.exports = __webpack_public_path__ + "img/e_3_14_g.718b69ac.png";